import * as React from 'react';
import { Dictionary } from '../../../entities/common';
import { ExtensionInfo, ExtensionPageLocation, findExtension } from '../../../store/ExtensionStore';
import { ApplicationState } from '../../../store';
import { connect } from 'react-redux';
import { buildExtensionsMenuItem } from '../headerMenuItemBuilders';
import ExtensionPanel from '../ExtensionPanel';
import { notUndefined } from '../../utils/common';
import { IContextualMenuItem } from 'office-ui-fabric-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import MenuWithAuditLog, { MenuWithAuditLogProps } from '../../audit/MenuWithAuditLog';

export type RowMenuWithExtensionsProps = MenuWithAuditLogProps & {
    context?: Dictionary<any>;
    commandsBefore?: IContextualMenuItem[];
    onRefresh?: () => void;
};

type StateProps = {
    extensions: ExtensionInfo[];
};

type Props = RowMenuWithExtensionsProps & StateProps & RouteComponentProps<{}>;

const RowMenuWithExtensions = (props: Props) => {
    const { extensions, entityType, commandsBefore, item, context } = props;
    const [isExtensionPanelOpen, setIsExtensionPanelOpen] = React.useState<ExtensionInfo>();
    
    const commands = [
        ...commandsBefore ?? [],
        ...(item.isEditable || item.allowExtensions ? buildExtensionsMenuItem(extensions, setIsExtensionPanelOpen) : []),
        ...props.commands
    ].filter(notUndefined);

    return <>
        <MenuWithAuditLog
            {...props}
            commands={commands}
        />
        {isExtensionPanelOpen && <ExtensionPanel
            entityType={entityType}
            info={isExtensionPanelOpen}
            onDismiss={() => setIsExtensionPanelOpen(undefined)}
            onRefresh={props.onRefresh}
            context={{ ...context, entityId: item?.id, entityType }}
        />}
    </>;
}

function mapStateToProps(state: ApplicationState, ownProps: RowMenuWithExtensionsProps): StateProps {
    return {
        extensions: findExtension(state.extensions, ownProps.entityType, ExtensionPageLocation.EntityAction, undefined, ownProps.item.sourceType)
    }
}

export default withRouter<RowMenuWithExtensionsProps>(connect(mapStateToProps)(RowMenuWithExtensions));